import * as React from 'react';
import './understandingCheck.module.scss';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';

type Props = {
    lessonIndex: number;
    sectionIndex: number;
    sectionTitle: string;
    onNextClick: () => any;
};

export class UnderstandingCheck extends React.Component<Props> {
    render() {
        const { lessonIndex, sectionIndex, sectionTitle, onNextClick } = this.props;
        return (
            <div styleName="understanding-check">
                <div styleName="text">理解したら次に進もう</div>
                <div styleName="section-title">
                    DAY {lessonIndex + 1}. {String(sectionIndex + 1).padStart(2, '0')} {sectionTitle}
                </div>
                <div styleName="button-wrapper">
                    <Button styleName="button" type="primary" size="m" onClick={onNextClick}>
                        次へ進む
                    </Button>
                </div>
            </div>
        );
    }
}
